import React from 'react';
import { Logo } from './Logo';
export const HeroSection = () => {
  return <section className="relative bg-gradient-to-b from-slate-50 to-slate-100 py-20 overflow-hidden" data-id="element-110" data-mp="2hut61v4fs34n">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111" data-mp="23v1ndh2z5ykb">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8" data-id="element-112" data-mp="23ww4slf1f8jn">
          <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left" data-id="element-113" data-mp="28tcvnndmg10f">
            <div className="mt-6" data-id="element-114" data-mp="2wjgwjmzfdmnq">
              <h1 className="text-4xl tracking-tight font-extrabold text-slate-800 sm:text-5xl md:text-6xl" data-id="element-115" data-mp="2wk8qktddjcbw">
                <span className="block" data-id="element-116" data-mp="30kj20ljxquy5">Aurum Grove Capital</span>
                <span className="block text-[#D4AF37]" data-id="element-117" data-mp="2msupwi9os6h6">
                  Cultivating wealth for generations
                </span>
              </h1>
              <p className="mt-6 text-base text-slate-600 sm:text-lg md:text-xl" data-id="element-118" data-mp="2rqntd3jlumdr">
                Aurum Grove Capital manages investments for a select group of
                family and friends in the Indian market, with a long-term
                approach focused on sustainable growth and wealth preservation.
              </p>
              <div className="mt-10 sm:flex sm:justify-center lg:justify-start" data-id="element-119" data-mp="2beq14vx4ourn">
                <div className="rounded-md shadow" data-id="element-120" data-mp="2p51vz2l3l7mh">
                  <a href="#contact" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#D4AF37] hover:bg-[#C9A227] md:py-4 md:text-lg md:px-10" data-id="element-121" data-mp="2p6wg4eojovpi">
                    Contact Us
                  </a>
                </div>
                <div className="mt-3 sm:mt-0 sm:ml-3" data-id="element-122" data-mp="384fttvly72i9">
                  <a href="#about" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-[#D4AF37] bg-white hover:bg-slate-50 md:py-4 md:text-lg md:px-10" data-id="element-123" data-mp="3823b3g8d8o45">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center" data-id="element-124" data-mp="3dseezasagavf">
            <div className="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md" data-id="element-125" data-mp="3ir95kywhz3q3">
              <div className="relative block w-full bg-white p-10 rounded-lg" data-id="element-126" data-mp="3mtm1kvlfzn9o">
                <Logo data-id="element-127" data-mp="3rs710ssve2x2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};